import { Camera, CalendarCheck, DollarSign, MessageCircle } from "lucide-react";
import phoneMockupAsset from "@/assets/phone-mockup-900.webp.asset.json";
const phoneMockup = phoneMockupAsset.url;

const features = [
  {
    icon: Camera,
    heading: "Fast Photo Quotes",
    description: "Send us photos and we'll quickly assess what needs removing.",
  },
  {
    icon: CalendarCheck,
    heading: "Easy Pickup Booking",
    description: "Choose a suitable time and we'll organise the rest.",
  },
  {
    icon: DollarSign,
    heading: "Clear, Upfront Pricing",
    description: "Know your agreed price before the job begins.",
  },
  {
    icon: MessageCircle,
    heading: "Easy Support & Updates",
    description: "Adding items or changing details? Our team is easy to reach.",
  },
];


const MovingSimpleSection = () => (
  <section className="bg-[#f7f7f7] py-16 md:py-24">
    <div className="container">
      <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
        {/* Left side */}
        <div className="w-full lg:w-1/2">
          <h2 className="text-3xl md:text-4xl font-black text-[#1a1a1a] leading-tight mb-10">
            Rubbish Removal Made Simple
          </h2>

          <div className="space-y-8">
            {features.map((f) => (
              <div key={f.heading} className="flex gap-4">
                <div className="shrink-0 w-10 h-10 rounded-lg bg-[#FDC00E]/15 flex items-center justify-center mt-0.5">
                  <f.icon className="w-5 h-5 text-[#1a1a1a]" strokeWidth={2} />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-[#1a1a1a] mb-1">
                    {f.heading}
                  </h3>
                  <p className="text-[#1a1a1a]/75 text-sm leading-relaxed">
                    {f.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <a
            href="/#quote"
            className="inline-block mt-10 bg-[#1a1a1a] text-white px-8 py-4 text-lg font-bold rounded-md hover:bg-orange transition-colors"
          >
            Get Free Quote
          </a>
        </div>

        {/* Right side - phone mockup */}
        <div className="w-full lg:w-1/2 flex items-center justify-center">
          <img
            src={phoneMockup}
            alt="Rubbish removal job tracking app showing pickup address, load size and live status updates"
            className="w-[70%] md:w-[60%] lg:w-[85%] max-w-md h-auto"
            loading="lazy"
            decoding="async"
            width={900}
            height={822}
          />
        </div>
      </div>
    </div>
  </section>
);

export default MovingSimpleSection;
